import { Component } from '@angular/core';
import { ClickOutsideDirective } from '../../shared/directives/click-outside.directive';
import {FeatherIconsComponent} from "../../shared/components/feather-icons/feather-icons.component";
import {ListComponent} from "./list/list.component";
import {EventsEvidenceFilesComponent} from "../service/event/events-evidence-files/events-evidence-files.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NewComponent} from "./new/new.component";


@Component({
  selector: 'app-task',
  standalone: true,
  imports: [ClickOutsideDirective, FeatherIconsComponent, ListComponent, ListComponent],
  templateUrl: './task.component.html',
  styleUrl: './task.component.scss'
})
export class TaskComponent {
  constructor(public modal: NgbModal) {
  }
}
